export const COLORS = {
  blue:      '#479EC3',
  blueDark:  '#3B88A9',
  blueDeep:  '#1A5E78',
  text:      '#0F2335',
  text2:     '#4A6070',
  text3:     '#8BA5B5',
  border:    '#E2E8F0',
  bg:        '#F9FAFB',
  white:     '#fff',
};

export const EASING = {
  spring: [0.22, 1, 0.36, 1],
};

export const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.65, ease: EASING.spring, delay },
});

export const ANIM = {
  stagger: {
    hidden: {},
    visible: { transition: { staggerChildren: 0.1 } },
  },
  staggerItem: {
    hidden:  { opacity: 0, y: 28 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASING.spring } },
  },
};
